<ng-container *ngIf="productIdentifier$ | async as productIdentifier">
	<div id="product-review-questions-and-answers" class="questions-and-answers-content hmf-m-l">
		<div data-bv-show="questions" [attr.data-bv-product-id]="productIdentifier">
			<div id="ratings-progress-spinner" class="ratings-progress-spinner">
				<common-progress-spinner [diameter]="40" [strokeWidth]="4"></common-progress-spinner>
			</div>
		</div>
	</div>
</ng-container>
